import { queryOptions } from '@tanstack/react-query';

import { workspaceService } from '@/services/database';

export const workspaceWhitelabelQueryKey = (workspaceId?: string) =>
    ['workspace', workspaceId ?? 'unavailable', 'whitelabel'] as const;

export const workspaceWhitelabelQueryOptions = (workspaceId?: string) =>
    queryOptions({
        enabled: Boolean(workspaceId),
        queryFn: () => {
            if (!workspaceId) {
                throw new Error('A workspace is required to load appearance settings.');
            }

            return workspaceService.getWhitelabel(workspaceId);
        },
        queryKey: workspaceWhitelabelQueryKey(workspaceId),
        staleTime: 30_000,
    });
